export const environment = {
  production: true,
  baseUrl: 'https://api.dah-qa.top',
  cabinetBaseUrl: 'https://cabinet.dah-qa.top',
  tempCabinetBaseUrl: 'https://temp.cabinet.dah-qa.top',
  ws: 'api.dah-qa.top',
  pbxUrl: 'pbx.dah-online.com',
  openApiLink: 'https://open.api.dah-qa.top/swagger-ui/index.html'
};
